module.exports = __webpack_public_path__ + "img/pdf.076be46d.svg";